import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Platform, Linking as RNLinking } from "react-native";
import { AuthScreenContainer } from "./AuthScreenContainer";
import { Button } from "./Button";
import { Text } from "./Text";
import { View } from "./View";
import { manifest } from "../constants";
/**
 * Renders error UI informing the user that something has gone wrong and the app
 * is not functioning as expected. Gives the user a button to attempt retrying
 * the failed action.
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̇̀̀̃̅̀̀̃́̀̀̃̃̀̀̆̃̀̀̆̄̀̀̆̃̀̀̃̀̀̀̂̍̀̀̃́̀̀̃̃̀̀̃̄̀̀̆̄̀̀̂̍̀̀̃̄̀̀̆́̀̀̃̃̀̀̃̄̀̀̂̍̀̀̆̂̀̀̃̆̀̀̆̃̀̀̆̃̀̀̂̍̀̀̆̆̀̀̃̄̀̀̃̀̀̀̆́̀̀̆̆̀̀̆̆̀̀̃̃̀̀̃̄̀̀̃́̀̀̆̆̀̀̆́̀̀̃̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃̅̀̀̃́̀̀̃̃̀̀̂̍̀̀̃́̀̀̃̆̀̀̃̃̀̀̃̂̀̀̃̄̀̀̃̈̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃̆̀̀̃̆̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̉̀̀̃̀̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-25}
 */ export function AppError(props) {
    return /*#__PURE__*/ _jsx(AuthScreenContainer, {
        heading: "Something went wrong",
        children: /*#__PURE__*/ _jsxs(View, {
            spacing: 40,
            style: {
                padding: Platform.OS === 'web' ? 20 : 0
            },
            children: [
                props.type === 'runtime' ? /*#__PURE__*/ _jsx(Text, {
                    text: "We're sorry, but something went wrong. Please try reloading ".concat(manifest.name, ".")
                }) : /*#__PURE__*/ _jsx(Text, {
                    text: "We're sorry, but we couldn't load ".concat(manifest.name, ". Please make sure you're connected to the internet.")
                }),
                /*#__PURE__*/ _jsxs(View, {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            text: "If you're in crisis, please call the National Suicide Prevention Lifeline."
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            text: "Call Lifeline",
                            onPress: function() {
                                return RNLinking.openURL('tel:988');
                            },
                            alignSelf: "flex-start",
                            variant: "text",
                            testID: "AppError_callLifelineButton"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    text: "Reload ".concat(manifest.name),
                    onPress: function() {
                        return props.retry();
                    },
                    testID: "AppError_reloadButton"
                })
            ]
        })
    });
}
